import { render, staticRenderFns } from "./BillEdit.vue?vue&type=template&id=96d2c1a8&scoped=true"
import script from "./BillEdit.vue?vue&type=script&lang=js"
export * from "./BillEdit.vue?vue&type=script&lang=js"
import style0 from "./BillEdit.vue?vue&type=style&index=0&id=96d2c1a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d2c1a8",
  null
  
)

export default component.exports